module.exports = __webpack_public_path__ + "static/media/HPIM0920_cr.de8e9fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plasticProducts/HPIM0920_cr.jpg
// module id = 245
// module chunks = 0